import React, { useState } from "react";
import { attendanceService } from "../../services/attendanceService";
import { useSelector } from "react-redux";
import { Table, Button, Container, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-bootstrap/Modal";

const AdminMonthlyAttendanceScreen = () => {
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [attendanceList, setAttendanceList] = useState([]);
  const [activeTab, setActiveTab] = useState("Indoor");
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedAttDetail, setSelectedAttDetail] = useState(null);
  const { userInfo } = useSelector((state) => state.auth);

  const handleViewDetails = (att) => {
    setSelectedAttDetail(att);
    setShowDetailModal(true);
  };

  const handleCloseDetailModal = () => {
    setShowDetailModal(false);
    setSelectedAttDetail(null);
  };

  const fetchAttendance = async () => {
    try {
      const empCode = userInfo && userInfo[1]?.InfoField;
      const companyCode = userInfo && userInfo[13]?.InfoField;

      const apiResponse = await attendanceService.getAdminMonthlyAttendance(
        selectedMonth.toString(),
        selectedYear.toString(),
        empCode,
        companyCode
      );
      setAttendanceList(Array.isArray(apiResponse) ? apiResponse : []);
    } catch (error) {
      console.error("Error fetching monthly attendance:", error);
      setAttendanceList([]);
    }
  };

  const filteredAttendance = attendanceList.filter(att => {
    if (activeTab === "Indoor") {
      return att.RangeType === "Indoor";
    } else if (activeTab === "Outdoor") {
      return att.RangeType === "Outdoor";
    }
    return true;
  });

  return (
    <Container>
      <h2 className="my-4">Admin Monthly Attendance</h2>
      <Row className="mb-3">
        <Col xs={12} md={4}>
          <DatePicker
            selected={new Date(selectedYear, selectedMonth - 1, 1)}
            onChange={(date) => {
              setSelectedMonth(date.getMonth() + 1);
              setSelectedYear(date.getFullYear());
            }}
            dateFormat="MM/yyyy"
            showMonthYearPicker
            className="form-control"
          />
        </Col>
        <Col xs={12} md="auto">
          <Button onClick={fetchAttendance}>Fetch Attendance</Button>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col>
          <Button
            variant={activeTab === "Indoor" ? "primary" : "light"}
            onClick={() => setActiveTab("Indoor")}
            className="me-2"
          >
            Indoor
          </Button>
          <Button
            variant={activeTab === "Outdoor" ? "primary" : "light"}
            onClick={() => setActiveTab("Outdoor")}
          >
            Outdoor
          </Button>
        </Col>
      </Row>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>View</th>
            <th>Name</th>
            <th>Type</th>
            <th>Entry Date</th>
            <th>Entry Time</th>
          </tr>
        </thead>
        <tbody>
          {filteredAttendance.map((att) => {
            const dateTimeParts = att.AttDateTime ? att.AttDateTime.split(' ') : [];
            const entryDate = dateTimeParts.length > 0 ? dateTimeParts[0] : '';
            const entryTime = dateTimeParts.length > 1 ? dateTimeParts[1].substring(0, 8) : '';

            return (
              <tr key={att.AttID}>
                <td>
                  <Button variant="primary" onClick={() => handleViewDetails(att)}>View</Button>
                </td>
                <td>{att.EmployeeName}</td>
                <td>{att.AttType}</td>
                <td>{entryDate}</td>
                <td>{entryTime}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>

      <Modal show={showDetailModal} onHide={handleCloseDetailModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Attendance Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedAttDetail && (
            <div>
              <h5>Employee Name: {selectedAttDetail.EmployeeName}</h5>
              <p>Type: {selectedAttDetail.AttType}</p>
              <p>DateTime: {selectedAttDetail.AttDateTime}</p>
              <p>Location: {selectedAttDetail.AttLocation}</p>
              {selectedAttDetail.AttImage && (
                <div>
                  <h6>Image:</h6>
                  <img
                    src={`https://payrollnodbodemo.magnussoftech.in/${selectedAttDetail.AttImage}`}
                    alt="Attendance" style={{ maxWidth: '100%', height: 'auto' }}
                  />
                </div>
              )}
              <p>Review Status: {selectedAttDetail.reviewsts}</p>
              <p>Range Type: {selectedAttDetail.RangeType}</p>
              {selectedAttDetail.OutDoorReason && <p>Outdoor Reason: {selectedAttDetail.OutDoorReason}</p>}
              <p>Work Hours: {selectedAttDetail.WorkHours}</p>
              <p>Work Remarks: {selectedAttDetail.WorkRemarks}</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDetailModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default AdminMonthlyAttendanceScreen; 